import { set } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  item: {},
  partnerships: [],
  query: {
    where: {
      partnershipId: []
    },
    sort: {
      createdAt: 'DESC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true,
      'page-text': '{{pageStart}}',
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdAt'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      }
    },
    filter: {
      partnershipId: [],
      keyword: '',
      activatedBy: '',
      generatedDate: [],
      activatedDate: [],
      pickupDate: [],
      status: [],
      reportTypes: []
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['createdAt'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type KitState = ReturnType<typeof state>;

export const mutations: MutationTree<KitState> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query.where, {
      partnershipId: filter.partnershipId,
      keyword: filter.keyword,
      activatedBy: filter.activatedBy,
      activatedAt: filter.activatedDate,
      createdAt: filter.generatedDate,
      requestPickupDate: filter.pickupDate,
      status: filter.status,
      reportTypes: filter.reportTypes
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.table.footer, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  },
  changePartnerships: (state, value) => {
    Object.assign(state.partnerships, value);
  },
  changeItem: (state, value) => {
    Object.assign(state.item, value);
  }
};
